/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      d="M9.75 10.5a.75.75 0 0 0-1.5 0V18a.75.75 0 0 0 1.5 0v-7.5ZM15 9.75a.75.75 0 0 1 .75.75V18a.75.75 0 0 1-1.5 0v-7.5a.75.75 0 0 1 .75-.75Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M.75 4.5a.75.75 0 0 0 0 1.5H3v13.5C3 21.9853 5.0147 24 7.5 24h9c2.4853 0 4.5-2.0147 4.5-4.5V6h2.25a.75.75 0 0 0 0-1.5H16.5C16.5 2.0147 14.4853 0 12 0S7.5 2.0147 7.5 4.5H.75ZM9 4.5h6c0-1.6568-1.3431-3-3-3s-3 1.3432-3 3ZM19.5 6h-15v13.5c0 1.6569 1.3431 3 3 3h9c1.6569 0 3-1.3431 3-3V6Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'Delete'
);
